export function dateToday(): string {
  return formatDate(new Date().toDateString(), "YYYY-MM-DD");
}

export type DateFormat =
  | "YYYY-MM-DD"
  | "YYYY-MM"
  | "YYYY-MM-DD HH:mm"
  | "D MMM YYYY"
  | "D MMM YYYY HH:mm"
  | "D MMM YYYY HH:mm:ss";

export function formatDate(
  dateString: Date | string | number | undefined | null,
  format: DateFormat,
): string {
  const date = typeof dateString === "object" && dateString !== null
    ? dateString
    : new Date(dateString ?? "");
  if (!isValidDate(date)) {
    return "";
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1; // JavaScript months are 0-based
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const monthNames = [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec",
  ];

  let formattedDate = "";

  switch (format) {
    case "YYYY-MM-DD":
      formattedDate = `${year}-${month.toString().padStart(2, "0")}-${
        day.toString().padStart(2, "0")
      }`;
      break;
    case "YYYY-MM":
      formattedDate = `${year}-${month.toString().padStart(2, "0")}`;
      break;
    case "YYYY-MM-DD HH:mm":
      formattedDate = `${year}-${month.toString().padStart(2, "0")}-${
        day.toString().padStart(2, "0")
      } ${hours.toString().padStart(2, "0")}:${
        minutes.toString().padStart(2, "0")
      }`;
      break;
    case "D MMM YYYY":
      formattedDate = `${day} ${monthNames[month - 1]} ${year}`;
      break;
    case "D MMM YYYY HH:mm":
      formattedDate = `${day} ${monthNames[month - 1]} ${year} ${
        hours.toString().padStart(2, "0")
      }:${minutes.toString().padStart(2, "0")}`;
      break;
    case "D MMM YYYY HH:mm:ss":
      formattedDate = `${day} ${monthNames[month - 1]} ${year} ${
        hours.toString().padStart(2, "0")
      }:${minutes.toString().padStart(2, "0")}:${
        seconds.toString().padStart(2, "0")
      }`;
      break;
  }

  return formattedDate;
}

export function isValidDate(d: object) {
  return d instanceof Date && !isNaN(d.getTime());
}

export function daysSince(dateString: string): number {
  const pastDate = new Date(dateString);
  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - pastDate.getTime();
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  return daysDifference;
}
